import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import {
  gAPI_Users_By_Id,
  gAPI_Property_List_By_Group,
} from '../../../../../../constants/APIs';
import roleListData from '../../../../../../data/rolelist.json';

export default function EditUsersForm({
  formLabel,
  visible,
  toggle,
  id,
  submit,
  userProperty,
  userRole,
  isSuperAdmin,
  serviceProvider,
  isViewMode,
}) {
  const [propertyList, setPropertyList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [roleList, setRolesList] = useState([]);
  const [usersData, setUsersData] = useState({
    email: '',
    properties: ['-1'],
    roles: ['Admin'],
    creator: 'dashboard',
    firstName: '',
    lastName: '',
    phoneNumber: '',
  });
  useEffect(() => {
    // if (id === getUserID()) {
    //   setIsDisabled(true);
    // }

    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${id}?gid=${getGroupID()}`,
    })
      .then((res) => {
        setUsersData(res.data);
        const userproperty = res.data.properties;
        setRolesList(
          roleListData.data.map((elem) => {
            elem.checked = false;
            res.data.roles.forEach((r) => {
              if (r === elem.id) {
                elem.checked = true;
              }
            });
            return elem;
          })
        );
        AxiosAPI({
          method: 'get',
          url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
        })
          .then((res1) => {
            var filterProperty = res1.data.map((elem) => {
              elem.checked = false;
              userproperty.forEach((r) => {
                if (r === elem.id) {
                  elem.checked = true;
                }
              });
              return elem;
            });
            if (userProperty.length > 0 && userProperty[0] !== '-1') {
              filterProperty = filterProperty.filter((p) =>
                userProperty.includes(p.id)
              );
            }

            setPropertyList(filterProperty);
          })
          .catch((err) => console.error(err));

        // Control disable state
        // if (isSuper) {
        //   setIsDisabled(false);
        // } else {
        //   setIsDisabled(true);
        // }
      })
      .catch((err) => console.log('err', err));
  }, [id]);

  const handleChange = (e) => {
    setUsersData({
      ...usersData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePropertiesChange = (e) => {
    const values = propertyList.map((elem) => {
      if (elem.id === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    setPropertyList(values);
  };

  const handleSelectAllProperties = (e) => {
    const checked = e.target.checked;
    setPropertyList((prev) =>
      prev.map((p) =>
        isPropertyDisabled(p.id)
          ? p
          : { ...p, checked }
      )
    );
  };

  const handleRoleChange = (e) => {
    const values = roleList.map((elem) => {
      if (elem.name === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    setRolesList(values);
  };

  useEffect(() => {
    const appPropertiesArr = propertyList
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.id);

    const appRolesArr = roleList
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.id);
    if (appPropertiesArr.length === 0) {
      appPropertiesArr.push('-1');
    }

    setUsersData({
      ...usersData,
      properties: appPropertiesArr,
      roles: appRolesArr,
    });
  }, [propertyList, roleList]);

  const isPropertyDisabled = (propertyId, superAdmin) => {
    const currentUserRoles = userRole || [];
    const isSuper = superAdmin || false;
    // SuperAdmin
    console.error(isSuper, 'isSuper');
    if (isSuper) return false;
    // Admin (disable properties not in userProperty)
    if (currentUserRoles.includes('Admin')) {
      return !userProperty.includes(propertyId);
    }
    // All other roles(everything disabled)
    return false;
  };

  const selectableProperties = propertyList.filter(
    (p) => !isPropertyDisabled(p.id)
  );

  const isAllPropertiesSelected =
    selectableProperties.length > 0 &&
    selectableProperties.every((p) => p.checked);


  const handleSubmit = () => submit(usersData);


  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          {/* <pre>{JSON.stringify(usersData, null, 2)}</pre> */}
          {usersData.firstName !== undefined ? (
            <Row className="mb-4">
              <Colxx xxs="12">
                <Row>
                  <Colxx sm={4} className="mb-3">
                    <Label>First Name</Label>
                    <Input className='input_sty'
                      type="text"
                      onChange={handleChange}
                      name="firstName"
                      value={usersData.firstName}
                      disabled={isViewMode}
                    />
                  </Colxx>
                  <Colxx sm={4} className="mb-3">
                    <Label>Last Name</Label>
                    <Input className='input_sty'
                      type="text"
                      onChange={handleChange}
                      name="lastName"
                      value={usersData.lastName}
                      disabled={isViewMode}
                    />
                  </Colxx>
                  <Colxx sm={4} className="mb-3">
                    <Label>Phone Number</Label>
                    <Input className='input_sty'
                      type="text"
                      onChange={handleChange}
                      name="phoneNumber"
                      value={usersData.phoneNumber}
                      disabled={isViewMode}
                    />
                  </Colxx>
                  <Colxx sm={4} className="mb-3">
                    <Label>Status</Label>
                    <Input className='input_sty'
                      type="select"
                      value={usersData.status}
                      name="status"
                      onChange={handleChange}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                      <option value="Deleted">Deleted</option>
                    </Input>
                  </Colxx>
                  {serviceProvider &&
                    (serviceProvider === '2' || serviceProvider === '5') && (
                      <Colxx sm={5} className="mb-3">
                        <Label>SynXis User ID</Label>
                        <Input className='input_sty'
                          type="text"
                          name="hsusername"
                          value={usersData?.hsUserName}
                          disabled
                        />
                      </Colxx>
                    )}
                </Row>
                <h4>Roles & Properties</h4>
                <Row>
                  <Colxx sm={4}>
                    <FormGroup>
                      <Label>Roles</Label>

                      {roleList.map((elem, index) => (
                        <Fragment>
                          <CustomInput
                            key={index}
                            type="checkbox"
                            value={elem.name}
                            id={elem.id}
                            onChange={handleRoleChange}
                            defaultChecked={elem.checked}
                            disabled={isViewMode}
                          >
                            {elem.name}
                          </CustomInput>
                        </Fragment>
                      ))}
                    </FormGroup>
                  </Colxx>

                  <Colxx sm={5}>
                    <FormGroup>
                      <Label>Properties</Label>

                      {/* Select All */}
                      <CustomInput
                        type="checkbox"
                        id="selectAllProperties"
                        label="Select All"
                        checked={isAllPropertiesSelected}
                        onChange={handleSelectAllProperties}
                        disabled={
                          isViewMode || selectableProperties.length === 0
                        }
                      />

                      {propertyList.map((p) => (
                        <CustomInput
                          key={p.id}
                          type="checkbox"
                          id={`prop-${p.id}`}
                          value={p.id}
                          onChange={handlePropertiesChange}
                          checked={p.checked}
                          disabled={isPropertyDisabled(p.id, isSuperAdmin || false)}
                        >
                          {p.name}
                        </CustomInput>
                      ))}
                    </FormGroup>
                  </Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : (
            <div className="loading" />
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            <IntlMessages id="dashboards.save" />
          </Button>
          <Button color="secondary" onClick={toggle}>
            <IntlMessages id="pages.cancel" />
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

EditUsersForm.propTypes = {
  // formLabel: PropTypes.string.isRequired,
  // visible: PropTypes.bool.isRequired,
  // toggle: PropTypes.func.isRequired,
  // updateRatePlansData: PropTypes.shape({
  //   name: PropTypes.array.isRequired,
  //   description: PropTypes.array.isRequired,
  //   conditions: PropTypes.array.isRequired,
  //   status: PropTypes.string.isRequired,
  // }),
  // applicableAddOnsWithIdAndName: PropTypes.array.isRequired,
  // includedAddOnsWithIdAndName: PropTypes.array.isRequired,
  // applicablePromosWithIdAndName: PropTypes.array.isRequired,
};
